import { render, staticRenderFns } from "./AgentApplicationCallback.vue?vue&type=template&id=883a84c0&scoped=true&"
import script from "./AgentApplicationCallback.vue?vue&type=script&lang=js&"
export * from "./AgentApplicationCallback.vue?vue&type=script&lang=js&"
import style0 from "./AgentApplicationCallback.vue?vue&type=style&index=0&id=883a84c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883a84c0",
  null
  
)

export default component.exports